module.exports = __webpack_public_path__ + "img/individual_usernames.d2c64826.svg";